module.exports = __webpack_public_path__ + "img/3f_r_bar2400@2x.997d7b74.jpg";